import LoggedOutFrame from "../../lib/logged_out_frame";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field, Fields, reduxForm } from "redux-form";
import { connect, useSelector } from "react-redux";
import { seedcastForm } from "../../../lib/forms";
import FormElement from "../../forms/form_element";
import Divider from "../../lib/divider";
import "./../../lib/radio-input/radio-input.scss";
import "./advertiser_sign_up.scss";
import { onCaptchaReady } from "../../../lib/captcha";
import LoadingButton from "../../forms/loading_button/loading_button";
import { createAdvertiserContact } from "../../../action_managers/advertiser_contact";
import { If } from "react-extras";
import { PhoneNumberInputComponent } from "../../forms/phone_input/phone_input";
import { withPageTitle } from "../../lib/WithPageTitle";

const FORM_NAME = "advertiser-sign-up";

const ContactForm = props => {
  const { validationErrors } = props;

  return (
    <form onSubmit={props.handleSubmit}>
      <Row>
        <Col xs={12} md={12}>
          <Field
            component={FormElement}
            name="brandName"
            label="Brand Name"
            type="text"
            validationErrors={validationErrors}
          />
        </Col>
        <Col xs={12} md={12}>
          <Field
            component={FormElement}
            name="website"
            label="Website"
            type="text"
            placeholder="https://yourbrandhere.com"
            validationErrors={validationErrors}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Field
            component={FormElement}
            name="fname"
            label="First Name"
            type="text"
            validationErrors={validationErrors}
            validationErrorKeyOverride="firstName"
          />
        </Col>
        <Col xs={12} md={6}>
          <Field
            component={FormElement}
            name="lname"
            label="Last Name"
            type="text"
            validationErrors={validationErrors}
            validationErrorKeyOverride="lastName"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={12}>
          <Field
            component={FormElement}
            name="role"
            label="Role"
            type="text"
            validationErrors={validationErrors}
          />
        </Col>
        <Col xs={12} md={12}>
          <Field
            component={FormElement}
            name="email"
            label="Email"
            type="text"
            validationErrors={validationErrors}
          />
        </Col>
        <Col xs={12} md={12}>
          <Fields
            names={["phoneNumber", "phoneNumberCountryCode"]}
            component={FormElement}
            InputComponent={PhoneNumberInputComponent}
            label="Phone Number"
            type="text"
            validationErrors={validationErrors}
          />
        </Col>
        <Col xs={12} md={12}>
          <Field
            component={FormElement}
            name="estimatedBudget"
            label="What's your estimated budget?"
            type="text"
            validationErrors={validationErrors}
          />
        </Col>
        <Col xs={12} md={12}>
          <Field
            component={FormElement}
            name="estimatedTimeline"
            label="What's your estimated timeline?"
            type="text"
            validationErrors={validationErrors}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Divider />
          <LoadingButton
            type="submit"
            disabled={!props.submitEnabled}
            className="btn btn-primary width-100"
            isLoading={props.isLoading}>
            Submit
          </LoadingButton>
          <div className="user-form__fine-print">
            By signing up, you agree to our{" "}
            <a href="https://redcircle.com/terms">Terms of Service</a> and{" "}
            <a href="https://redcircle.com/privacy">Privacy Policy</a>. This site is protected by
            reCAPTCHA and the Google{" "}
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
            <a href="https://policies.google.com/terms">Terms of Service</a>{" "}
          </div>
        </Col>
      </Row>
    </form>
  );
};

const ContactFormRedux = reduxForm({
  form: FORM_NAME,
  initialValues: {
    phoneNumberCountryCode: "US",
  },
})(ContactForm);
const ContactFormWrapper = seedcastForm(ContactFormRedux);

let AdvertiserSignUpPage = props => {
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const validationErrors = useSelector(state => state.advertiserSignUp.validationErrors);
  const isLoading = useSelector(state => state.advertiserSignUp.isLoading);

  const [isSubmitted, setSubmitted] = useState(false);

  useEffect(() => {
    onCaptchaReady(() => setSubmitEnabled(true));
  }, []);

  const submit = formData => {
    formData.firstName = formData.fname;
    formData.lastName = formData.lname;
    props.createAdvertiserContact(formData).then(response => {
      if (response.status === 200) {
        setSubmitted(true);
      }
    });
  };

  const title = isSubmitted ? "Great, we'll be reaching out soon" : "Advertiser Account Sign Up";
  const subtitle = isSubmitted ? (
    "We've received your information and someone from our team will reach out shortly."
  ) : (
    <div>
      Are you an advertiser or brand seeking to advertise? Fill out a few details to request a
      business account, and we’ll reach out to you with next steps. If you're not an advertiser,
      please sign up through the
      <a href="https://app.redcircle.com/sign-up"> Podcaster Sign Up </a> or
      <a href="https://app.redcircle.com/sign-up/sponsor"> Listener Sign Up </a> instead.
    </div>
  );
  return (
    <LoggedOutFrame className="advertiser-sign-up-page" title={title} subTitle={subtitle}>
      <Row className="sign-up-row">
        <Col xs={12} md={6} mdOffset={3}>
          <If condition={!isSubmitted}>
            <ContactFormWrapper
              validationErrors={validationErrors}
              onSubmit={submit}
              submitEnabled={submitEnabled}
              isLoading={isLoading}
            />
          </If>
        </Col>
      </Row>
    </LoggedOutFrame>
  );
};

AdvertiserSignUpPage = connect(
  () => {
    return {};
  },
  {
    createAdvertiserContact,
  }
)(AdvertiserSignUpPage);

export default withPageTitle(AdvertiserSignUpPage, "Advertiser Contact");
